module.exports = __webpack_public_path__ + "static/media/83.67852cc3.jpg";